// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"644":"89cad903ddc011d28e43","672":"d52d16cf4856eefe9689","811":"5329b0a8d035cef53bd4"}[chunkId] + ".js";
};